export const formResetHandler = (data) => {
  let resetObj = {};
  for (let key in data) {
    resetObj[key] = "";
  }
  return resetObj;
};
